export const SUBJECT_LIST = "SUBJECT_LIST";
export const SUBJECT_LIST_DATA = "SUBJECT_LIST_DATA";
export const SUBJECT_LIST_ERROR = "SUBJECT_LIST_ERROR";